import store from '../store/index.js'
import moment from 'moment-timezone'


let arrayStatus = {
// Sucesso
    //200: 'Status de sucesso não documentado',
    //201: 'Mensagem criada no servidor',
    //202: 'Recebida pelo telefone pareado',
    203: 'Enviada para a operadora',
    //204: 'Recebida pelo servidor',
    205: 'Entregue',

    206: 'Enviado',

    //207: 'Abriu',
    208: 'Respondida',
    //Transacional
    //300: 'Status transacional não documentado',
    301: 'Tentando enviar novamente',
    302: 'Enviando',

//Erros
    //500: 'Status de erro não documentado',
    501: 'Tempo de vida expirado',
    502: 'Mensagem inválida',
    /*503: 'Mensagem rejeitada',
    504: 'Mensagem não pode ser entregue',
    505: 'Mensagem apagada',
    506: 'Falha genérica',
    507: 'Sem serviço',
    508: 'PDU nulo',
    509: 'Rede de dados desativada',*/
    510: 'Erro ao entregar mensagem',
    511: 'Créditos do Astandes insuficientes',
    512: 'Erro de duplicidade',
    513: 'Número inválido'
}

let arrStatusAgendamento = {
    0: 'agendado',
    1: 'processando',
    2: 'processado',
    3: 'cancelado'
}

export const getDateTimeZoneBR = (data) => {
    try {
        let user = store.modules.system.state.user_local

        //return moment(data).tz(user.timezone).format('DD/MM/YYYY HH:mm:ss')
        return moment(data).format('DD/MM/YYYY HH:mm:ss')
    } catch(e) {
        return moment(data).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')
    }
}

export const getStatusSms = (status) => {
    let type
    if (status >= 200 && status <= 299) {
        type = 'primary'
    } else if (status >= 300 && status <= 399) {
        type = 'green'
    } else if (status >= 500 && status <= 599) {
        type = 'red'
    }else {
        type = 'secondary'
    }

    return { status: (status == 201 ) ? 'Enviado' : (status in arrayStatus) ? arrayStatus[status] : 'Sem status', type }
}

export const getAllStatusSms = () => {
    return Object.keys(arrayStatus).map(i => { return {status: i, descricao: arrayStatus[i]} })
}


export const getStatusAgendamento = (status) => {
    let arrStatusAgendamento = {
        0: {
            status: 'agendado'
        },
        1: {
            status: 'processando'
        },
        2: {
            status: 'processado'
        },
        3: {
            status: 'cancelado'
        },
        4: {
            status: 'erro'
        }
    }

    return arrStatusAgendamento[status]
}


export const getAllStatusAgendamento = () => {
    return Object.keys(arrStatusAgendamento).map(i => { return {status: i, descricao: arrStatusAgendamento[i]} })
}


export const nomeMes = (mes) => {
    let meses = {
        1: 'Janeiro',
        2: 'Fevereiro',
        3: 'Março',
        4: 'Abril',
        5: 'Maio',
        6: 'Junho',
        7: 'Julho',
        8: 'Agosto',
        9: 'Setembro',
        10: 'Outubro',
        11: 'Novembro',
        12: 'Dezembro'
    }

    return meses[mes]
}

export const convertSeconds = (seconds) => {
    return seconds ? moment.utc(seconds * 1000).format("HH:mm:ss") : 0;
}



// WEBPACK FOOTER //
// ./src/helpers/helpers.js